module.exports = __webpack_public_path__ + "img/medium.777bb848.webp";